import * as React from 'react';
import Fab from '@material-ui/core/Fab';

const CustomFab = (props) => {
    return <Fab {...props} />;
};

export { CustomFab as Fab };
